import { FC } from 'react'
import clsx from 'clsx'

export interface INavIconProps {
  icon: FC
  className?: string
}

/** Иконка пункта меню: не сжимается, когда подпись переносится или не влезает */
export const NavIcon = ({ icon: Icon, className }: INavIconProps) => {
  return (
    <div className={clsx('min-w-fit', className)}>
      <Icon />
    </div>
  )
}
